import React, { Fragment, useContext } from "react";

import LoadingPage from "../../react_utils/LoadingPage";
import PageInstructions from "./help/PageInstructions";
import TabView from "../../react_utils/TabView";
import InternetInstructions from "./help/InternetInstructions";
import MiscInstructions from "./help/MiscInstructions";
import { AuthContext } from "../../shared/contexts/AuthContext";
import CustomerLocationClient from "../../shared/api/CustomerLocationClient";
import useLocation from "../../shared/hooks/location/useLocation";

export default function Help() {
  const { apiClient } = useContext(AuthContext);

  const locationClient = new CustomerLocationClient(apiClient);

  const { location } = useLocation(locationClient);

  if (!location) return <LoadingPage />;
  return (
    <Fragment>
      <TabView
        components={[
          {
            title: "Webseite",
            getChild: () => <PageInstructions location={location} />,
          },
          {
            title: "Internetverbindung",
            getChild: () => <InternetInstructions location={location} />,
          },
          {
            title: "Sonstiges",
            getChild: () => <MiscInstructions location={location} />,
          },
        ]}
      />
    </Fragment>
  );
}

Help.propTypes = {};
